<template>
  <dd-radio :value="value">
    <div class="flex-row justify-content-between align-items-center gap-xxs">
      {{ title }}
      <dd-information-tooltip placement="right">{{ info }}</dd-information-tooltip>
    </div>
  </dd-radio>
</template>

<script>
export default {
  name: "AutomationTypeRadio",
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    title: {
      type: String,
      required: true
    },
    info: {
      type: String,
      required: false,
    }
  }
};
</script>

<style scoped>

</style>
